var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPercentAdd = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0547 7.30078C12.676 7.30078 13.1797 7.80446 13.1797 8.42578V11.8008H16.5547C17.176 11.8008 17.6797 12.3045 17.6797 12.9258C17.6797 13.5471 17.176 14.0508 16.5547 14.0508H13.1797V17.4258C13.1797 18.0471 12.676 18.5508 12.0547 18.5508C11.4334 18.5508 10.9297 18.0471 10.9297 17.4258V14.0508H7.55469C6.93337 14.0508 6.42969 13.5471 6.42969 12.9258C6.42969 12.3045 6.93337 11.8008 7.55469 11.8008H10.9297V8.42578C10.9297 7.80446 11.4334 7.30078 12.0547 7.30078Z",
    fill: "#1F292E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPercentAdd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_percent_add.d062f10db08cea45d7055d77e72eee5a.svg";